import { render, staticRenderFns } from "./PartnershipManagerList.vue?vue&type=template&id=85216f12&scoped=true&"
import script from "./PartnershipManagerList.vue?vue&type=script&lang=js&"
export * from "./PartnershipManagerList.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipManagerList.vue?vue&type=style&index=0&id=85216f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85216f12",
  null
  
)

export default component.exports